import { ModelShowPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$owner/activity/$id/')({
  component: RouteComponent
});

function RouteComponent() {
  const { id: modelId } = Route.useParams();

  return <ModelShowPage model="event" modelId={modelId} />;
}
